"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const conversation = (sdk) => {
    const { sdkConfig: { url }, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        saveConversationMessageSentiment: async (conversationId, payload) => {
            const endpoint = `${url}/v4/conversations/${conversationId}/sentiment`;
            const result = await httpClient.post(endpoint, { payload });
            return result.data;
        },
        getConversations: async (payload) => {
            const endpoint = `${url}/v4/conversations`;
            const result = await httpClient.get(endpoint, { query: payload });
            return result;
        },
        deleteConversation: async (conversationId) => {
            const endpoint = `${url}/v4/conversations/${conversationId}`;
            const result = await httpClient.delete(endpoint);
            return result.data;
        },
        getConversation: async (conversationId) => {
            const endpoint = `${url}/v4/conversations/${conversationId}`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
    };
};
exports.default = conversation;
